"use client";

import React, { useEffect, useState } from "react";
import * as s from "./index.module.scss";
import { IoArrowForward } from "react-icons/io5";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";
import Popups from "../Popups";
import Link from "next/link";

const AboutMB = ({
  title = "About Manhattan Buyers",
  text = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  call = false,
  data = {},
  page,
  buttonsDisabled,
  title_fw_style,
}) => {
  const tell = data?.mobile_number || "";
  let desc = "";
  let descText = false;

  if (call) {
    desc = data?.contact_us_description;
    descText = true;
  } else {
    desc = data?.about_mb_description;
    descText = true;
  }

  const [windowWidth, setWindowWidth] = useState(0);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className={`section-center ${s.about_mb}`}>
      <div className={s.about_mb_wrapper}>
        <div className={s.bg_image_container}>
          <article className={s.bg_image_container_inner}>
            <img
              loading="lazy"
              src={
                !call && windowWidth < 768
                  ? data?.mobile_image?.url || "" //580
                  : !call && windowWidth < 800
                    ? data?.tab_image?.url || ""
                    : !call && windowWidth < 1024
                      ? data?.desktop_image?.url || ""
                      : !call && windowWidth < 1400
                        ? data?.large_desktop_image?.url || ""
                        : !call && windowWidth >= 1400
                          ? data?.large_desktop_image?.url || ""
                          : ""
              }
              alt={data?.contact_us_desktop_image?.alt || "image"}
            />
          </article>
        </div>
        <article className={s.article_content}>
          <div className={s.text_content}>
            <h3 className={title_fw_style}>
              {call
                ? data?.contact_us_title || ""
                : data?.about_mb_title || title}
            </h3>
            {descText ? (
              <div className={`${secondaryFont} title`}>
                <PrismicRichText field={desc || []} />
              </div>
            ) : (
              <p className={`${secondaryFont} title`}>{text}</p>
            )}
            {!buttonsDisabled && (
              <div style={{ display: "flex", gap: "10px" }}>
                <Link
                  href={data?.about_mb_view_more_link || ""}
                  className={`btn btn-outline-dark ${secondaryFont}`}
                >
                  View More{" "}
                  <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
                </Link>
                <button
                  className={`btn btn-primary ${secondaryFont}`}
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  Get an offer now{" "}
                  <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
                </button>
              </div>
            )}
          </div>
        </article>
      </div>
      <Popups
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        page={page}
      />
    </section>
  );
};

export default AboutMB;
